'use client';

import { type PublicationStatus } from '@prisma/client';
import { useMemo } from 'react';

import { getPublicationImageUrl } from '@/shared/lib';

export default function useProcessImagesFromLinks(
  imagesInput: string[] | string | null | undefined,
  publicationId: string,
  loadImagesCount = 3,
  status?: PublicationStatus
): string[] {
  return useMemo(() => {
    // Нормализуем то, что прилетает из API/БД
    const picturesArray = Array.isArray(imagesInput)
      ? imagesInput
      : (imagesInput ?? '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);

    const imagesToLoad = picturesArray.slice(0, Math.max(0, loadImagesCount));

    return imagesToLoad.map((imageName) => {
      if (!imageName) return '';

      const url =
        getPublicationImageUrl({
          publicationId,
          imageName,
          status,
          bucketName: 'pets-sale-bucket'
        }) ?? '';

      return url;
    });
  }, [imagesInput, publicationId, loadImagesCount, status]);
}
